export enum BmarkContainerBlotterId {
  BMARK_SUMMARY = "BmarkSummaryContainerComponent",
  HEDGE_ORDER_MONITOR = "BfxHedgeOrderMonitorComponent",
}
